new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if(contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if(photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');
    
                    if(photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');
    
                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                              content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }
        
                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                              activeTab(index);
                            });
                        });
                    }
                }
            }

            if(photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();
            
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
            const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.resizeThumbs();
        this.clickThumbs();

        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        // Código para funcionar com elementos clonados pelo Slick
        const photoArea = document.querySelector('.product-detail__header--photoArea');
        const photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');
        
        if(photoThumbs && photoArea) {

                
                // Função para atualizar imagem e classes
                const updateImageAndClasses = (clickedLi) => {
                    const imgElement = clickedLi.querySelector('img');
                    if (imgElement) {
                        const newSrc = imgElement.getAttribute('src');
                        const newTitle = imgElement.getAttribute('title');
                        
                        // Atualizar o Vue data
                        this.imgSrc = newSrc;
                        this.imgTitle = newTitle;
                        
                        // Atualizar classes active
                        const allListItems = photoList.querySelectorAll('li');
                        allListItems.forEach((item) => {
                            item.classList.remove('active');
                        });
                        
                        // Adicionar active ao item clicado e seus clones
                        const dataIndex = clickedLi.getAttribute('data-slick-index');
                        if (dataIndex !== null) {
                            const allItemsWithSameIndex = photoList.querySelectorAll(`li[data-slick-index="${dataIndex}"]`);
                            allItemsWithSameIndex.forEach((item) => {
                                item.classList.add('active');
                            });
                        }
                        
                        // Atualizar imagem principal
                        const mainImage = document.querySelector('#product-photo img');
                        if (mainImage) {
                            mainImage.setAttribute('src', newSrc);
                            mainImage.setAttribute('title', newTitle);
                        }
                    }
                };

                // Usar delegação de eventos para capturar cliques em qualquer item (original ou clonado)
                photoList.addEventListener('click', (event) => {
                    const clickedLi = event.target.closest('li');
                    if (clickedLi && clickedLi.closest('#photo-list')) {
                        updateImageAndClasses(clickedLi);
                        
                        // Atualizar o slide ativo no Slick se estiver inicializado e tiver 5 ou mais slides
                        const $photoList = $('#photo-list');
                        if ($photoList.hasClass('slick-initialized')) {
                            const totalSlides = $photoList.find('.slick-slide:not(.slick-cloned)').length;
                            if (totalSlides >= 5) {
                                const dataIndex = clickedLi.getAttribute('data-slick-index');
                                if (dataIndex !== null) {
                                    $photoList.slick('slickGoTo', parseInt(dataIndex));
                                }
                            }
                        }
                    }
                });

                // Aguardar o Slick ser inicializado antes de definir o primeiro item como ativo
                setTimeout(() => {
                    const firstOriginalItem = photoList.querySelector('li:not(.slick-cloned)');
                    if (firstOriginalItem) {
                        updateImageAndClasses(firstOriginalItem);
                    }
                }, 100);
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if(ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                    ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    }
})

$(document).ready(function () {

    const brinde = document.querySelector('#js_buy_together_api_layout_2');

    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });
        
        observer.observe(brinde, {
            childList: true,
            subtree: true
        });
        
    }

    $("body").on("click", '.minus', function(event) {
        var qtd = $('#product_qtd__product_detail').val();

        if (qtd == 1) {
            return;
        } else {
            qtd--;
            $('#product_qtd__product_detail').val(qtd);
            $('#product_qtd__product_detail').attr('value', qtd)
        }
    });

    $("body").on("click", '.plus', function(event) {
        var qtd = $('#product_qtd__product_detail').val();

        qtd++;
        $('#product_qtd__product_detail').val(qtd);
        $('#product_qtd__product_detail').attr('value', qtd)
    });

    const galleryCarrousel = document.querySelector('.gallery-carrousel');
    if(galleryCarrousel) {
        $('.gallery-carrousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 1000,
            vertical: false,
        });
    }

    const photoList = document.querySelector('#photo-list');
    if(photoList) {
        $('#photo-list').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            speed: 700,
            vertical: true,
        }).on('afterChange', function(event, slick, currentSlide) {
            // Atualizar quando o slide muda no carrossel
            const currentItem = photoList.querySelector(`li[data-slick-index="${currentSlide}"]`);
            if (currentItem) {
                const imgElement = currentItem.querySelector('img');
                if (imgElement) {
                    const newSrc = imgElement.getAttribute('src');
                    const newTitle = imgElement.getAttribute('title');
                    
                    // Atualizar o Vue data
                    const vueApp = document.querySelector('#product-detail').__vue__;
                    if (vueApp) {
                        vueApp.imgSrc = newSrc;
                        vueApp.imgTitle = newTitle;
                    }
                    
                    // Atualizar classes active
                    const allListItems = photoList.querySelectorAll('li');
                    allListItems.forEach((item) => {
                        item.classList.remove('active');
                    });
                    
                    // Adicionar active ao item atual e seus clones
                    const allItemsWithSameIndex = photoList.querySelectorAll(`li[data-slick-index="${currentSlide}"]`);
                    allItemsWithSameIndex.forEach((item) => {
                        item.classList.add('active');
                    });
                    
                    // Atualizar imagem principal
                    const mainImage = document.querySelector('#product-photo img');
                    if (mainImage) {
                        mainImage.setAttribute('src', newSrc);
                        mainImage.setAttribute('title', newTitle);
                    }
                }
            }
        });
    }
    
    $('#photo-list').on('wheel', function(e) {
        e.preventDefault(); // impede o scroll normal da página
        if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickPrev');
        } else {
            $(this).slick('slickNext');
        }
    });

    const photoMobile = document.querySelector('.product-detail__header--photoArea-mobile');
    if(photoMobile) {
        $('.product-detail__header--photoArea-mobile').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    $('#product-detail-related-carrousel').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });

    $('.product__colors.attribute').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            },
        ]
    });

    $('#photo-fancy').fancybox();

    const headers = document.querySelectorAll('.product-detail__description-tab h2');
    const descriptions = document.querySelectorAll('.description');

    headers.forEach(header => {
        header.addEventListener('click', () => {
        headers.forEach(h => h.classList.remove('active'));
        descriptions.forEach(description => description.classList.remove('active'));

        header.classList.add('active');

        const index = header.getAttribute('data-index');

        const activeDescription = document.querySelector(`.description[data-index="${index}"]`);
        activeDescription.classList.add('active');
        });
    });
})